/**
 * Created by r4zi4l on 25.01.2021
 */

const Harvested = function (slot) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;

    this.config = Harvested.CONFIG[Map2dLocation.currentLocation.location.locationId] || {};

    this.level = 0;
    this.items = {};

    this.load();
};

Harvested.prototype = Object.create(cleverapps.EventEmitter.prototype);
Harvested.prototype.constructor = Harvested;

Harvested.prototype.load = function () {
    const stored = this.slot.load("harvested") || {};
    if (stored.items) {
        this.level = stored.level;
        this.items = stored.items;
    } else {
        this.level = 0;
        this.items = stored;
    }
};

Harvested.prototype.save = function () {
    let stored = this.items;

    if (this.level) {
        stored = {
            level: this.level,
            items: this.items
        };
    }

    this.slot.save("harvested", stored);
};

Harvested.prototype.onChange = function () {
    this.trigger("onChangeItems");

    if (Map2d.currentMap) {
        Map2d.currentMap.customers.onRecipesUpdated();
    }

    cleverapps.toolbar.resetByType(ToolbarItem.ORDERS);
    cleverapps.sideBar.resetByClassName(WarehouseIcon);
};

Harvested.prototype.get = function (code) {
    return this.items[code] || 0;
};

Harvested.prototype.add = function (code, value, silent) {
    this.items[code] = (this.items[code] || 0) + value;
    this.save();
    if (!silent) {
        this.onChange();
    }
};

Harvested.prototype.canTake = function (code, value) {
    return this.items[code] && this.items[code] >= value;
};

Harvested.prototype.isIngredientAvailable = function (ingredient) {
    return Boolean(this.config.resources ? this.config.resources[ingredient] : cleverapps.unitsLibrary.listCodesByType("fruit").includes(ingredient));
};

Harvested.prototype.canTakeList = function (ingredients) {
    for (const code in ingredients) {
        if (!this.canTake(code, ingredients[code])) {
            return false;
        }
    }
    return true;
};

Harvested.prototype.take = function (code, value) {
    if (this.canTake(code, value)) {
        this.items[code] -= value;
        this.save();
        this.onChange();
        return true;
    }
    return false;
};

Harvested.prototype.takeList = function (ingredients) {
    if (this.canTakeList(ingredients)) {
        for (const code in ingredients) {
            this.items[code] -= ingredients[code];
        }
        this.save();
        this.onChange();
        return true;
    }
    return false;
};

Harvested.prototype.calcMissingIngredients = function (ingredients) {
    const result = {};

    for (const code in ingredients) {
        const amount = ingredients[code] - this.get(code);
        if (amount > 0) {
            result[code] = amount;
        }
    }
    return result;
};

Harvested.resolveResourceFrame = function (frame) {
    if (!frame || !frame.key) {
        return frame;
    }

    const locationId = cleverapps.meta.selectedLocationId();
    const locationBundle = bundles[`resource_icons_${locationId}`];
    return locationBundle && locationBundle.frames[frame.key] || frame;
};

Harvested.prototype.getIngredientIcon = function (ingredientCode) {
    let icon;

    const data = this.config.resources && this.config.resources[ingredientCode];
    if (data && data.icon) {
        icon = new cc.Sprite(Harvested.resolveResourceFrame(data.icon));
    } else {
        const stage = Map2dLocation.currentLocation.location.locationConfig.ingredientIconStage || 0;

        icon = UnitView.getUnitImage({
            code: ingredientCode,
            stage
        }, { preferStatic: true });
    }

    return icon;
};

Harvested.prototype.getIngredientSmallIcon = function (ingredient) {
    let icon;

    const data = this.config.resources && this.config.resources[ingredient];
    if (data && data.smallIcon) {
        icon = new cc.Sprite(Harvested.resolveResourceFrame(data.smallIcon));
    } else if (data && data.icon) {
        icon = new cc.Sprite(Harvested.resolveResourceFrame(data.icon));
    } else {
        icon = this.getIngredientIcon(ingredient);
    }

    cleverapps.UI.fitToBox(icon, cleverapps.styles.Reward.smallIcon);

    return icon;
};

Harvested.prototype.getIngredientName = function (ingredient) {
    const data = this.config.resources && this.config.resources[ingredient];
    if (data) {
        return Messages.get(`Ingredient.${ingredient}.name`);
    }

    return cleverapps.unitsLibrary.getUnitName({
        code: ingredient,
        stage: Map2dLocation.currentLocation.location.locationConfig.ingredientIconStage || 0
    });
};

Harvested.prototype.listResources = function () {
    return Object.keys(this.items).filter((ingredient) => !this.config.resources || this.config.resources[ingredient]).map((ingredients) => ({
        ingredient: ingredients,
        amount: this.items[ingredients] || 0
    }));
};

Harvested.prototype.getItemsAmount = function () {
    return Object.values(this.items).reduce((result, amount) => result + amount, 0);
};

Harvested.prototype.getCapacity = function () {
    return (this.config.capacity || 0) + this.level * 20;
};

Harvested.prototype.hideCapacity = function () {
    return this.config.hideCapacity;
};

Harvested.prototype.getExchangeMinimum = function () {
    return this.config.exchangeMinimum || 0;
};

Harvested.prototype.isFull = function () {
    return this.getItemsAmount() >= this.getCapacity();
};

Harvested.prototype.isAlmostFull = function () {
    return this.getItemsAmount() / this.getCapacity() >= 0.9;
};

Harvested.prototype.upgradeCapacity = function () {
    this.level += 1;
    this.save();
    this.onChange();
};

Harvested.prototype.getUpgradePrice = function () {
    return this.config.price || 0;
};

Harvested.prototype.needsToShowTip = function () {
    this.wantsToShowTip = true;

    Map2dLocation.currentLocation.counter.setTimeout(() => {}, 0);
};

Harvested.prototype.showHint = function () {
    if (!this.wantsToShowTip || cleverapps.focusManager.isFocused()) {
        return;
    }

    cleverapps.focusManager.display({
        focus: "warehouseGuide",
        actions: [
            function (f) {
                cleverapps.timeouts.setTimeout(f, 500);
            },

            function (f) {
                new WarehouseWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            },

            function (f) {
                this.wantsToShowTip = false;
                f();
            }.bind(this)
        ]
    });
};

Harvested.CONFIG = {

};

UniversalSlot.registerTable("harvested", {
    getInfo: (slot) => slot.load("harvested") || {},
    updateInfo: (slot, serverData) => slot.save("harvested", serverData, true)
});
